export default __webpack_public_path__ + "static/media/logo.fb84b11d.png";